/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { MouseTracker } from "src/classes/plate/Mouse/MouseTracker";
import { PositionUtils } from "src/classes/utilities/PositionUtils";
import { StyledData } from "src/components/Plate/Data/styles";

interface Props {
  mouseTracker: MouseTracker;
}
export function MousePosition({ mouseTracker }: Props) {
  const x = mouseTracker.observe((state) => state.position.x);
  const y = mouseTracker.observe((state) => state.position.y);
  return <StyledData>{`[${PositionUtils.snapToGrid(x)}, ${PositionUtils.snapToGrid(y)}]`}</StyledData>;
}
